import Review from './Review'

export default {
  name: 'Review',
  component: Review
}
